import { assertEvent, assign } from 'xstate5';

import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Stores the required ingredient name when attempting to remove a required modification.
 */
export const storeRequiredIngredientName: CustomizationMachineAction = assign(
  (args) => {
    const { context, event } = args;

    assertEvent(event, [
      'customization.remove-modification',
      'customization.remove-modification-completely',
    ]);

    const { ingredientId } = event;
    const modification = context.allModificationsMap?.get(ingredientId);

    return {
      requiredIngredientName: modification?.ingredient?.name,
    };
  },
);
